import React, { useState } from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
} from '@chakra-ui/react'

export default function DeleteConfirmModal({ handle, onConfirm, onCancel }) {
  const [isDeleting, setIsDeleting] = useState(false)

  const handleDelete = async () => {
    setIsDeleting(true)
    try {
      await onConfirm()
    } catch (error) {
      setIsDeleting(false)
    }
  }

  return (
    <Modal isOpen={true} onClose={onCancel} isCentered>
      <ModalOverlay bg="blackAlpha.700" />
      <ModalContent bg="#131316" border="1px solid" borderColor="#27272a">
        <ModalHeader color="#fafafa">Confirm Delete</ModalHeader>
        <ModalBody>
          <Text color="#d4d4d8">
            Are you sure you want to remove <strong>{handle}</strong>?
          </Text>
        </ModalBody>
        <ModalFooter gap={3}>
          <Button
            bg="#27272a"
            color="#d4d4d8"
            border="1px solid"
            borderColor="#3f3f46"
            _hover={{ bg: '#3f3f46' }}
            onClick={onCancel}
            isDisabled={isDeleting}
          >
            Cancel
          </Button>
          <Button
            colorScheme="red"
            onClick={handleDelete}
            isLoading={isDeleting}
            loadingText="Deleting"
          >
            Delete
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
